import type { Channel, Uuid, WelcomeScreen } from "@shared/api";
import { Dialog } from "@shared/ui/bits";
import { Button } from "@shared/ui/button";
import { IconTextChannel } from "@shared/ui/icons";

/**
 * Окно приветствия новичку — как в Discord: «Добро пожаловать на …», пара слов
 * о сервере и каналы, с которых стоит начать. Щелчок по каналу ведёт в него.
 */
export function WelcomeModal({
  serverName,
  screen,
  channels,
  onOpenChannel,
  onClose,
}: {
  serverName: string;
  screen: WelcomeScreen;
  channels: Channel[];
  onOpenChannel: (channelId: Uuid) => void;
  onClose: () => void;
}) {
  const shown = (screen.channels ?? []).filter((item) => channels.some((channel) => channel.id === item.channel_id));

  return (
    <Dialog
      title={`Добро пожаловать на сервер «${serverName}»!`}
      onClose={onClose}
      actions={
        <Button type="button" onClick={onClose}>
          Начать общение
        </Button>
      }
    >
      {screen.description && <p className="welcome-about">{screen.description}</p>}
      {shown.length > 0 && (
        <div className="welcome-list">
          <span className="welcome-list-title">С чего начать</span>
          {shown.map((item) => {
            const channel = channels.find((entry) => entry.id === item.channel_id)!;
            return (
              <button
                key={item.channel_id}
                type="button"
                className="welcome-pick"
                onClick={() => {
                  onOpenChannel(item.channel_id);
                  onClose();
                }}
              >
                <span className="welcome-pick-emoji">{item.emoji ?? <IconTextChannel size={16} />}</span>
                <span className="welcome-pick-text">
                  <b>{item.description}</b>
                  <span className="muted">#{channel.name}</span>
                </span>
              </button>
            );
          })}
        </div>
      )}
    </Dialog>
  );
}
